import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { Container, Header, Grid, Button, Loader, Popup, Label, Segment } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";
import { format } from "date-fns";

import TableApp, { ITableAppRender } from "../../components/TableApp";

import errors from "../../Utils/ExtractErrors";
import OpenedRepository, { IOpened, IOpenedParams } from "../../Repositories/OpenedKits";
import CustomLoader from "../../components/CustomLoader";

const Opened: React.FC = () => {

    const date = new Date();
    const [list, setList] = useState<IOpened[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<IOpenedParams>({ year: date.getFullYear().toString(), month: (date.getMonth() + 1).toString() });

    const load = async () => {

        setLoading(true);
        try {

            const response = await OpenedRepository.Opened({
                year: state.year,
                month: state.month
            });

            setList(response);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    };

    useEffect(() => { load() }, []);

    const setStatus = (status: number) => {
        switch (status) {
            case 0:
                return <Label ribbon icon="box" content="EST" />
            case 1:
                return <Label ribbon icon="user" color="pink" content="GES" />             
            case 2:
                return <Label ribbon icon="id badge" color="violet" content="REP" />
            case 3:
                return <Label ribbon icon="street view" color="teal" content="REV" />
            case 4:
                return <Label ribbon icon="stopwatch" color="blue" content="PRE" />
            default:
                return <Label ribbon icon="dont" color="grey" content="???" />
        }
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Status",
            content: (x: IOpened) => setStatus(x.status),
            textAlign: "left",
            width: 1
        },
        {
            header: "Kit",
            content: (x: IOpened) => x.numero,
            textAlign: "left",
            width: 1
        },
        {
            header: "Representante",
            content: (x: IOpened) => x.representante,
            textAlign: "left",
            width: 5
        },
        {
            header: "Revendedor",
            content: (x: IOpened) => x.revendedor,
            textAlign: "left",
            width: 5
        },
        {
            header: "Acerto",
            content: (x: IOpened) => format(new Date(x.acerto), "dd/MM/yyyy"),
            textAlign: "center",
            width: 2
        },
    ];

    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                {loading ? <Segment><CustomLoader /></Segment> :
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Header size="huge" content={`Kit's em aberto`} icon="folder open outline" />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Button
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Atualizar"
                                    onClick={load}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column>
                            <Grid.Row>
                                <TableApp
                                    render={tableRender}
                                    list={list}
                                    loading={loading}
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                }
            </Container>
            <Footer />
        </>
    );
};

export default Opened;
